import { useAuth } from "@/hooks/useAuth";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export function ImpersonationBanner() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const stopMutation = useMutation({
    mutationFn: async () => {
      const res = await apiRequest("POST", "/api/auth/stop-impersonating");
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
      window.location.href = "/?role=broker";
    },
  });

  if (!user?.isImpersonating) return null;

  const orig = user.originalUser;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-amber-950 px-4 py-1.5 flex items-center justify-between text-sm h-9">
      <div className="flex items-center gap-2">
        <ShieldAlert className="h-4 w-4" />
        <span>
          <strong>Impersonating:</strong> {user.firstName} {user.lastName} ({user.email}) — Role: {user.role}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-amber-700 bg-amber-600 text-white hover:bg-amber-700 hover:text-white"
        onClick={() => stopMutation.mutate()}
        disabled={stopMutation.isPending}
      >
        {stopMutation.isPending ? "Restoring..." : "Stop Impersonating"}
      </Button>
    </div>
  );
}
